import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import * as utils from "./Utils.js";
import { shuttleStops } from "../data/transportationLocations.js";

const SHUTTLE_NAMES = [...new Set(shuttleStops.map((s) => s.shuttle))];

const AdminGuests = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [guests, setGuests] = useState([]);
  const [reservationsById, setReservationsById] = useState({});
  const [saving, setSaving] = useState({});

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
        fetchData();
      } else {
        window.location.href = "/login";
      }
    });
    return () => unsubscribe();
  }, []);

  const fetchData = async () => {
    const [guestSnap, resSnap] = await Promise.all([
      getDocs(collection(db, "guests")),
      getDocs(collection(db, "reservations")),
    ]);

    const loadedGuests = guestSnap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((g) => {
        const events = g.events || [];
        if (!events.length) return true;
        return events.some((e) => e.rsvp !== "no");
      })
      .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    setGuests(loadedGuests);

    const resMap = {};
    resSnap.docs.forEach((d) => { resMap[d.id] = d.data(); });
    setReservationsById(resMap);
  };

  const setShuttle = async (guest, value) => {
    const newShuttle = guest.shuttle === value ? null : value;
    setSaving((prev) => ({ ...prev, [guest.id]: true }));
    await updateDoc(doc(db, "guests", guest.id), { shuttle: newShuttle });
    setGuests((prev) =>
      prev.map((g) => g.id === guest.id ? { ...g, shuttle: newShuttle } : g)
    );
    setSaving((prev) => ({ ...prev, [guest.id]: false }));
  };

  const shuttleLabel = (shuttle) => {
    if (!shuttle) return <span className="text-muted">—</span>;
    if (shuttle === "any") return <span className="badge" style={{ background: "#9ccccb", color: "#00233f" }}>any</span>;
    return <span>{shuttle}</span>;
  };

  return (
    <div className="AdminGuests">
      <div className="centered-box wedding-page-block">

        <div className="wedding-centerpiece">
          <p style={{ margin: "15px 0 0 0", width: "100%" }}>
            <a
              style={{ textDecoration: "none", color: "#00233f", padding: "5px", border: "1px solid transparent" }}
              href="/admin"
            >
              <b>← Back to Admin</b>
            </a>
          </p>
          <p className="wedding-page-title">Guests</p>
        </div>

        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead>
            <tr>
              <th>Guest</th>
              <th>Reservation</th>
              <th>Shuttle</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {guests.map((guest) => {
              const res = reservationsById[guest.reservation_id];
              const isAny = guest.shuttle === "any";
              // isAny used for the Any button state
              return (
                <tr key={guest.id}>
                  <td>{guest.name || <em className="text-muted">unnamed</em>}</td>
                  <td>{res?.name || <em className="text-muted">—</em>}</td>
                  <td>{shuttleLabel(guest.shuttle)}</td>
                  <td>
                    <div className="d-flex flex-wrap gap-1">
                      {SHUTTLE_NAMES.map((name) => {
                        const active = guest.shuttle === name;
                        const label = name.replace("Shuttle ", "");
                        return (
                          <button
                            key={name}
                            className={`btn btn-sm ${active ? "btn-navyblue" : "btn-outline-navyblue"}`}
                            style={{ fontSize: 11, padding: "1px 7px" }}
                            onClick={() => setShuttle(guest, name)}
                            disabled={!!saving[guest.id]}
                          >
                            {label}
                          </button>
                        );
                      })}
                      <button
                        className={`btn btn-sm ${isAny ? "btn-navyblue" : "btn-outline-navyblue"}`}
                        style={{ fontSize: 11, padding: "1px 7px" }}
                        onClick={() => setShuttle(guest, "any")}
                        disabled={!!saving[guest.id]}
                      >
                        {saving[guest.id] ? "…" : "Any"}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

      </div>

      <div className="centered-box">
        {utils.displayCheckerboard(20, 42, ["black", "ivory"])}
      </div>
    </div>
  );
};

export default AdminGuests;
